import { ThemeConfig } from "antd";

// New Design System colors (dark mode)
const colors = {
  primary: "#FF5879",
  primaryForeground: "#ffffff",
  background: "#1f1f1f",
  foreground: "#f0f0f0",
  card: "#2a2a2a",
  secondary: "#3a3a3a",
  muted: "#3a3a3a",
  mutedForeground: "#a0a0a0",
  border: "#4a4a4a",
  destructive: "#ef4444",
  success: "#22c55e",
  warning: "#f59e0b",
};

export const BlingsTheme: ThemeConfig = {
  token: {
    // Typography
    fontSizeSM: 10,
    fontSize: 12,
    fontSizeLG: 12,
    fontFamily: `Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,

    // Primary colors
    colorPrimary: colors.primary,
    colorInfo: colors.primary,
    colorLink: colors.primary,

    // State colors
    colorError: colors.destructive,
    colorSuccess: colors.success,
    colorWarning: colors.warning,

    // Text colors
    colorText: colors.foreground,
    colorTextBase: colors.foreground,
    colorTextSecondary: colors.mutedForeground,
    colorTextPlaceholder: colors.mutedForeground,
    colorTextDisabled: "rgba(255, 255, 255, 0.4)",
    colorTextDescription: colors.mutedForeground,

    // Background colors
    colorBgLayout: colors.background,
    colorBgContainer: colors.card,
    colorBgElevated: colors.card,

    // Border colors
    colorBorder: colors.border,
    colorBorderSecondary: colors.muted,

    // Border radius
    borderRadius: 8,
    borderRadiusLG: 10,
  },
  components: {
    Layout: {
      headerBg: colors.background,
      siderBg: colors.background,
      bodyBg: colors.background,
    },
    Button: {
      defaultHoverBg: "transparent",
      boxShadow: "none",
      primaryShadow: "none",
    },
    TreeSelect: {
      nodeSelectedBg: colors.secondary,
      colorBorder: colors.border,
    },
    Spin: {
      colorPrimary: colors.foreground,
    },
    Input: {
      colorTextPlaceholder: "rgba(255, 255, 255, 0.5)",
      activeBg: colors.background,
      hoverBg: colors.background,
      colorBgContainer: colors.background,
      colorBorder: colors.border,
      activeBorderColor: colors.primary,
      hoverBorderColor: colors.border,
    },
    Switch: {
      colorPrimary: colors.primary,
      colorPrimaryHover: colors.primary,
      handleBg: colors.background,
    },
    InputNumber: {
      colorText: colors.foreground,
      colorTextBase: colors.foreground,
      colorTextPlaceholder: "rgba(255, 255, 255, 0.5)",
      fontWeightStrong: 400,
      colorBorder: colors.border,
      activeBorderColor: colors.primary,
      hoverBorderColor: colors.border,
    },
    Radio: {
      buttonCheckedBg: colors.mutedForeground,
      buttonSolidCheckedBg: colors.mutedForeground,
      buttonSolidCheckedHoverBg: colors.mutedForeground,
      buttonBg: "transparent",
      buttonColor: colors.mutedForeground,
    },
    Cascader: {
      optionSelectedBg: colors.secondary,
      controlItemBgHover: colors.background,
      colorBorder: colors.border,
    },
    Select: {
      optionSelectedBg: colors.secondary,
      optionActiveBg: colors.muted,
      colorBorder: colors.border,
      activeBorderColor: colors.primary,
      hoverBorderColor: colors.border,
    },
    Tag: {
      defaultColor: colors.mutedForeground,
    },
    Modal: {
      contentBg: colors.card,
      headerBg: colors.card,
    },
    Dropdown: {
      colorBgElevated: colors.card,
    },
    Popover: {
      colorBgElevated: colors.card,
    },
    Tooltip: {
      colorBgSpotlight: colors.card,
    },
    Menu: {
      itemSelectedBg: colors.secondary,
      itemHoverBg: colors.muted,
    },
    Table: {
      headerBg: colors.background,
      rowHoverBg: colors.muted,
    },
    Collapse: {
      headerBg: colors.card,
      contentBg: colors.background,
    },
    Tabs: {
      itemSelectedColor: colors.primary,
      itemHoverColor: colors.primary,
      inkBarColor: colors.primary,
    },
    Slider: {
      trackBg: colors.primary,
      trackHoverBg: colors.primary,
      handleColor: colors.primary,
      handleActiveColor: colors.primary,
    },
    Checkbox: {
      colorPrimary: colors.primary,
      colorPrimaryHover: colors.primary,
    },
    DatePicker: {
      colorBorder: colors.border,
      activeBorderColor: colors.primary,
      hoverBorderColor: colors.border,
    },
    Segmented: {
      // Pill-shaped segmented control styling
      trackBg: colors.muted,
      trackPadding: 4,
      itemColor: colors.mutedForeground,
      itemHoverColor: colors.foreground,
      itemHoverBg: "transparent",
      itemSelectedBg: colors.card,
      itemSelectedColor: colors.foreground,
      itemActiveBg: colors.card,
    },
  },
  cssVar: {
    key: "blings",
  },
};

export default BlingsTheme;
